// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  Fragment,
} from 'react';

import TrialWelcomeModalHeader from '@zapier/design-system-company/src/components/TrialWelcomeModalHeader';
import { List } from '@zapier/design-system-microlibrary-shared';
import { Heading, Link, Margin, Spacer, Text } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import TrialWelcomeModalTopicLink from './TrialWelcomeModalTopicLink';
import topics from '../topics';

import { type Size } from '@zapier/design-system-company/src/types';

/** @jsx isolateComponent */

type Props = {
  /** Callback to be executed when the modal is closed */
  onClose: () => void,
  /** Call to change modal route */
  onRoute: string => void,
  /** Size */
  size: Size,
};

const Styles = labelStyles(__filename, {
  buttonWrapper: {
    textAlign: 'center',
  },

  heading: {
    padding: '44px 0',
    textAlign: 'center',
  },

  imageWrapper: {
    textAlign: 'center',
  },

  link: {
    textDecoration: 'underline',
  },

  topicLinksWrapper: {
    '& > *': {
      marginBottom: 10,
    },
  },
});

const TrialWelcomeModalGuideView = (props: Props) => (
  <Fragment>
    <TrialWelcomeModalHeader>
      <div css={Styles.heading}>
        <Heading>
          <Text color="white" type="subtitle900">
            Getting started with Zapier for Companies
          </Text>
        </Heading>
        <Spacer height={8} />
        <Text color="white" type="bodyText900">
          Select an option below to continue setup
        </Text>
      </div>
    </TrialWelcomeModalHeader>

    <Margin margin="30px 0">
      <Margin margin={`0 ${props.size === 'small' ? '20px' : '80px'}`}>
        <div css={Styles.topicLinksWrapper}>
          <List
            gap={5}
            itemRenderer={item => (
              <TrialWelcomeModalTopicLink
                onClick={() => props.onRoute(item.id)} // +2 because default page is 0 and Guide page is 1
                text={item.title}
              />
            )}
            items={topics}
          />
        </div>
      </Margin>

      <Spacer height={30} />

      <Text color="grey700" tag="p" textAlign="center" type="altText900">
        More questions?{' '}
        <Link
          color="grey700"
          css={Styles.link}
          href="/help/account/companies/get-started-with-zapier-for-companies"
          onClick={props.onClose}
        >
          View our documentation.
        </Link>
      </Text>

      <Text color="grey700" tag="p" textAlign="center" type="altText900">
        New to Zapier?{' '}
        <Link
          color="grey700"
          css={Styles.link}
          href="/learn/getting-started-guide"
          onClick={props.onClose}
        >
          Read our Getting Started guide.
        </Link>
      </Text>
    </Margin>
  </Fragment>
);

export default TrialWelcomeModalGuideView;
